// import { component } from 'vue/types/umd'


export default [
    { path: '/', redirect: '/modulelist' },//重定向,页面默认加载的路由
    { path: '/home/:account', redirect: '/modulelist/:account' },//双重定向,页面默认加载的路由
    { path: '/401', component: () => import('../page/errorPage/401'), hidden: true,props($route) {
            return {
                code: $route.query.code,
                msg: $route.query.msg
            }
        }
    },
    { path: '/404', component: () => import('../page/errorPage/404'), hidden: false },//服务不存在  
    { name: 'modulelist', path: '/modulelist/:account', component: () => import('../page/ModuleList'), meta: { isAuth: false, title: '模块列表' },
    props:true },
    { name: 'modulelistitem', path: '/modulelistitem/:model_place', component: () => import('../page/ModuleListItem'), props: true,meta: { isAuth: true, title: '模块列表详情' }},
    { name: 'happyreading', path: '/happyreading', component: () => import('../page/Happyreading/HappyReading'),props: true, meta: { isAuth: true, title: '快乐读书吧' }},  
    { name: 'happyreadinglist', path: '/happyreadinglist/:happy_name', component: () => import('../page/Happyreading/HappyReadingList'),props: true, meta: { isAuth: true, title: '快乐读书年级列表' }
    },    
    // {
    //     name: 'moduleitemdetail', path: '/moduleitemdetail/:model_id/:model_type/:model_name/:model_place', component: () => import('../page/ModuleItemDetail'),

    //     props: true,
    //     meta: { isAuth: true, title: '推荐图书' }
    // },
    { name: 'moduleitemdetail', path: '/moduleitemdetail/:model_place', component: () => import('../page/ModuleItemDetail'),props: true,meta: { isAuth: true, title: '推荐图书' }
    },
    { name:'moduleitemdetailvideo',path:'/moduleitemdetailvideo/:model_id/:model_type/:model_name/:model_place',component:()=>import('../page/ModuleItemDetailVideo'),props:true,meta:{isAuth:true,title:'视频详情'}
    },
    { name: 'moduleprebookdetail', path: '/moduleprebookdetail/:tag_id/:model_place', component: () => import('../page/ModuleItemDetail'),props: true,meta: { isAuth: true, title: '分级导读' }},
    { name: 'guidedetailpage', path: '/guidedetailpage/:book_id', component: () => import('../page/GuideDetailPage'),
        props: true,
        meta: { isAuth: true, title: '导读详情' },
        props:true
    },   
    { name:'startevaluation', path: '/startevaluation', component: () => import('../page/Evaluation/StartEvaluation'), meta: {isAuth: true, title: '开始测评'}},
    { name:'startbookevaluation', path: '/startbookevaluation/:book_id', component: () => import('../page/AfterReadingEvaluation/StartBookEvaluation'), props:true,meta: {isAuth: true, title: '开始测评'}},
    { name: 'evaluationresult', path: '/evaluationresult/:appraisalHistoryTag/:isList', component: () => import('../page/Evaluation/EvaluationResult'),
        props:true,           
        meta: { isAuth: true, title: '测评结果' },
        children: [
            {
                name: 'allquestlook', path: '/allquestlook/:appraisalHistoryTag', component: () => import('../page/Evaluation/AllQuestLook'),
                meta: { isAuth: true, title: '查看对错题' }
            },
            {
                name: 'recommendbook', path: '/recommendbook', component: () => import('@/page/Evaluation/RecommendBook'),
                meta: { isAuth: true, title: '书单内容' }
            }
        ],           
    },
    {name:'afterreadingquestpage',path:'/afterreadingquestpage/:salesbookHistoryTag/:topicNumber',component:()=>import('../page/AfterReadingEvaluation/AfterReadingQuestPage.vue'),props:true,
    meta:{isAuth:true,title:'读后测试'}
    },
    {
        name: 'afterreadingtestrecord', path: '/afterreadingtestrecord/:salesbookHistoryTag', component: () => import('../page/AfterReadingEvaluation/AfterReadingTestRecord'),
        props:true,           
        meta: { isAuth: true, title: '读后测试报告' },
        children: [
            {
                name: 'allquestlook', path: '/allquestlook/:appraisalHistoryTag/:salesbookHistoryTag', component: () => import('../page/Evaluation/AllQuestLook'),
                meta: { isAuth: true, title: '查看对错题' }
            },
            {
                name: 'recommendbook', path: '/recommendbook', component: () => import('../page/Evaluation/RecommendBook'),
                meta: { isAuth: true, title: '书单内容' }
            }
        ],           
    },

    {
        name: 'evaluationarticle', path: '/evaluationarticle', component: () => import('../page/EvaluationArticle'),
        meta: { isAuth: true, title: '测评文章' },
    },
    { name: 'audio', path: '/audio', component: () => import('../page/Audio') },
    {
        name: 'questpage', path: '/questpage/:appraisalHistoryTag/:topicNumber',
        component: () => import('../page/Evaluation/QuestPage'), meta: { isAuth: true, title: '答题页面' },
        props: true
    },
    {
        name: 'bookmagazine', path: '/bookmagazine/:model_id/:resource_id/:model_place', component: () => import('../page/BookMagazine'),
        props: true,
        meta: { isAuth: true, title: '翻书插件' }
    },
   { name:'evarecordlist', path: '/evarecordlist', component: () => import('../page/EvaRecordList'), meta: {isAuth: true, title: '测评报告列表'}},
   { name:'facerecognition', path: '/facerecognition', component: () => import('../page/FaceRecognition'), meta: {isAuth: true, title: '人脸识别'}},
   {name:'keyboard',path:'/keyboard',component:()=>import('../page/KeyBoard'),meta:{isAuth:false,title:'小键盘'}}
]

